<nav class="sidebar">
  <app-sidebar />
</nav>

<main class="content flex-grow-1 p-3">
  <router-outlet />
</main>
